<div class="breadcrumb-section new-item" *ngIf= "largeDevices">
    <div class="container">
        <div class="row">
              <ul class="bread">
                <li >
                </li>
                <li *ngFor= "let i of breadCrumbData;let index=index">
                  <a (click)= "navigateTo(i,index+1)" class="animate__animated animate__fadeIn">{{i.title | titlecase}}</a>
                </li>
              </ul>
        </div>
    </div>
    </div>
